(function () {
    /** @ngInject */
    function successPageController($scope, $state, Booking) {
        $scope.booking = Booking;
        $scope.booking.initFromDbObj(_booking);
        $scope.no_show_text = _.has(_booking, 'no_show_text') ? _booking.no_show_text : false;
        $scope.confirmBooking = function () {
            if (typeof (window.top) !== 'undefined')
                window.top.postMessage('scrollTop', "*");
            if (_.has(settings, 'waitb') && _.has(settings, 'lid') && settings.waitb.length > 4 && !_.isUndefined(_booking)) {
                $scope.booking.terms.general = true;
                $scope.booking.save().success(function (response) {
                    if (response.success !== true) {
                        alert(response.errors);
                        return false;
                    } else {
                        window.location = '/reservation/booking/?code=' + response.booking.short_code + '&do_confirm=1';
                        return true;
                    }
                });
            } else {

                if (settings.confirm_in_widget === true || $scope.booking.payinwidget === true) {
                    $state.go('payinwidget', {}, { location: false });
                } else {
                    window.location = '/reservation/booking/?code=' + $scope.booking.short_code + '&do_confirm=1';
                    return;
                }
            }
        };
        $scope.$on("$viewContentLoaded", function () {
            updateWidgetStep('Success');
        });
    }

    angular.module("Waiteraid").controller("successCtrl", successPageController);
})();
